var map = {
	"./Forme_1.png": 1629,
	"./Forme_3.png": 228,
	"./arrow-down.png": 1630,
	"./attente.png": 1631,
	"./barratio.jpeg": 1632,
	"./bell-alarm-symbol.png": 1633,
	"./bfast.png": 1634,
	"./bouteille.png": 514,
	"./burger.png": 515,
	"./checked.png": 222,
	"./clipboard.png": 1635,
	"./copied.png": 516,
	"./copy.png": 517,
	"./easilys.jpg": 1636,
	"./fleche rouge.png": 1637,
	"./gift-icon.png": 1638,
	"./gift_.png": 1639,
	"./gstock.png": 1640,
	"./guestonline.png": 1641,
	"./guestonline2.png": 1642,
	"./help.svg": 1643,
	"./illus-niveau1-partenaire.svg": 1644,
	"./info.png": 518,
	"./logo-text-white.png": 1645,
	"./logo.png": 1646,
	"./logo_plein.png": 511,
	"./logo_symbol.png": 185,
	"./netresto.jpg": 1647,
	"./netresto.png": 1648,
	"./nonintegrated.png": 224,
	"./pause.png": 223,
	"./ronds-confirmation-formulaire.svg": 512,
	"./snapshift.png": 1649,
	"./the_fork.png": 1650,
	"./userborder.svg": 227,
	"./validé.png": 1651,
	"./verre.png": 513,
	"./zenchef.png": 1652,
	"./zenchef2.jpg": 1653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 667;